<template>
  <v-dialog v-model="dialog" v-if="item" max-width="300">
    <v-card>
      <v-card-title>
        {{ title }}
        <v-icon color="warning">warning</v-icon>
      </v-card-title>
      <v-card-text>Do you want to remove {{ item.name }}?</v-card-text>
      <v-card-actions>
        <v-container>
          <v-row>
            <v-col cols="6">
              <v-btn block @click="confirm">Yes</v-btn>
            </v-col>
            <v-col cols="6">
              <v-btn block @click="close">Cancel</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component
export default class ConfirmDeleteDialog extends Vue {
  @Prop(Object) item
  @Prop(String) title
  dialog = false

  confirm () {
    this.$emit('confirm-delete')
    this.close()
  }

  open () {
    this.dialog = true
  }

  close () {
    this.dialog = false
  }
}

</script>
